// extracted by mini-css-extract-plugin
export default {"payment":"Success_payment__zGngz","item":"Success_item__9uQUy"};